import script from "./LightGroupMessage.vue?vue&type=script&setup=true&lang=ts"
export * from "./LightGroupMessage.vue?vue&type=script&setup=true&lang=ts"

import "./LightGroupMessage.vue?vue&type=style&index=0&id=cbc13b94&scoped=true&lang=less"

import exportComponent from "/Users/neal/www/bonwey/qingtv-back-new/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cbc13b94"]])

export default __exports__